import { Box } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DestinationTimingKbn, EmailClass } from "../../assets/data/Constants";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { GlobalContext } from "../../context/globalContext";
import { IAPI_TEM003_Request } from "../../type/apiType";
import {
  DestinationTiming2,
  SendBegIntegerime,
} from "../SCRW140002/components";
import { httpAPI_TEM002, httpAPI_TEM003, httpAPI_TEM004 } from "./api/request";
import { schema, tableList } from "./parts";
import _ from "lodash";

/**
 * テンプレート詳細
 * 機構職員がメールテンプレートを更新する。
 * @return SCRW140003
 */
const SCRW140003 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, setState } = useContext(GlobalContext);
  const [stateTableList, setStateTableList] = useState(_.cloneDeep(tableList));
  const [resInit, setResInit] = useState<any>({});
  const [destinationTiming1Obj, setDestinationTiming1] = useState("");
  const [timing2, setTiming2] = useState<any>({});
  const [sendTime, setSendTime] = useState("");
  const [modalText, setModalText] = useState("");
  const [httpReq, setHttpReq] = useState<any>({});
  const [open, setOpen] = useState(false);
  const [upDateBtn, setUpDateBtn] = useState(false);

  const handleCallApiInit = async () => {
    try {
      let resArr = stateTableList;
      let destinationTiming2 = resArr.find(
        (item) => item.keyword === "destinationTiming2"
      )!;
      let sendBegIntegerime = resArr.find(
        (item) => item.keyword === "sendBegIntegerime"
      )!;
      // 送信タイミング1
      let destinationTiming1Show = resArr.find(
        (item) => item.keyword === "destinationTiming1"
      )!;
      // 送信タイミング2
      let destinationTiming2Show = resArr.find(
        (item) => item.keyword === "destinationTiming2"
      )!;
      // 送信時刻
      let sendBegIntegerimeShow = resArr.find(
        (item) => item.keyword === "sendBegIntegerime"
      )!;

      // メールテンプレート参照API呼び出し
      const res = await httpAPI_TEM002({
        tempId: location.state?.tempId,
      });

      if (res.resultCd === "I0000") {
        setResInit(res);

        // 項目 表示/非表示
        if (res.emailClass === EmailClass["定期案内メール用テンプレート"]) {
          destinationTiming1Show.showLine = true;
          destinationTiming2Show.showLine = true;
          sendBegIntegerimeShow.showLine = true;
          setUpDateBtn(true);
        }

        // 初期値を設定
        for (let i in res) {
          let targetObj = resArr.find((item) => item.keyword === i)!;

          if (targetObj) {
            targetObj.setDefaultValue = res[i as keyof typeof res];
            targetObj.text = res[i as keyof typeof res];
          }
        }

        // 送信タイミング2の設定
        const _month = res.destinationTiming1Time?.slice?.(0, 2);
        const _day = res.destinationTiming1Time?.slice?.(2, 4);
        let timeObj = {
          day:
            res.destinationTiming1 === DestinationTimingKbn["月次"]
              ? res.destinationTiming2Day
              : _day,
          month: _month,
          date: res.destinationTiming1Date,
        };
        if (destinationTiming2) {
          destinationTiming2.node = (
            <DestinationTiming2
              type={res.destinationTiming1}
              onChange={(e: any) => setTiming2(e)}
              defaultValue={timeObj}
            />
          );
        }

        // 送信時刻の設定
        if (sendBegIntegerime) {
          sendBegIntegerime.node = (
            <SendBegIntegerime
              onChange={(e: any) => setSendTime(e)}
              defaultValue={res.sendBegIntegerime}
            />
          );
        }

        setStateTableList([...resArr]);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 初期表示
  useEffect(() => {
    handleCallApiInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 送信タイミング１の更新
  useEffect(() => {
    let resArr = stateTableList;
    let destinationTiming1 = resArr.find(
      (item) => item.keyword === "destinationTiming1"
    )!;
    destinationTiming1.onGetValue = (data: any) => {
      setDestinationTiming1(data);
    };
    setStateTableList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  // 送信タイミング2の更新
  useEffect(() => {
    let resArr = stateTableList;
    let destinationTiming2 = resArr.find(
      (item) => item.keyword === "destinationTiming2"
    )!;
    destinationTiming2.node = (
      <DestinationTiming2
        type={destinationTiming1Obj}
        onChange={(e: any) => setTiming2(e)}
      />
    );
    setStateTableList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [destinationTiming1Obj]);

  const mailHttpObj = (obj: any): IAPI_TEM003_Request => {
    const _month = timing2?.month?.padStart?.(2, "0") ?? "";
    const _day = timing2?.day?.padStart?.(2, "0") ?? "";
    let reqObj: IAPI_TEM003_Request = {
      tempId: resInit.tempId,
      emailClass: obj.emailClass,
      tempName: obj.tempName,
      title: obj.title,
      text: obj.text,
      destinationTiming1: obj.destinationTiming1,
      destinationTiming2Day:
        obj.destinationTiming1 === DestinationTimingKbn["月次"]
          ? timing2.day
          : undefined,
      destinationTiming1Time:
        obj.destinationTiming1 === DestinationTimingKbn["四半期"] ||
        obj.destinationTiming1 === DestinationTimingKbn["年次"]
          ? _month + _day
          : undefined,
      destinationTiming1Date:
        obj.destinationTiming1 === DestinationTimingKbn["個別に指定"]
          ? timing2.date
          : undefined,
      sendBegIntegerime: sendTime,
    };

    return reqObj;
  };

  const handleSubmit = (data: any, index: any) => {
    switch (index) {
      case 0: // 更新
        setModalText("更新");
        setHttpReq({ ...mailHttpObj(data) });
        setOpen(true);
        break;

      case 1: // 削除
        setModalText("削除");
        setOpen(true);
        break;
    }
  };

  const handleOk = async (type: any) => {
    try {
      let res: any = {};

      switch (type) {
        case "更新":
          res = await httpAPI_TEM003({ ...httpReq }); // メールテンプレート更新API呼び出し
          break;

        case "削除":
          res = await httpAPI_TEM004({ tempId: resInit.tempId }); // メールテンプレート削除API呼び出し
          break;
      }
      if (res.resultCd === "I0000") {
        navigate("/SCRW140001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };
  return (
    <Box data-testid="SCRW140003">
      <TkFakeTable
        list={stateTableList}
        ruleSchema={schema}
        buttonGroup={<TkBackButton />}
        submitButtonGroup={[
          { submitButtonText: "更新", showButton: upDateBtn },
          { submitButtonText: "削除" },
        ]}
        onCheckAndSubmit={(e, index) => handleSubmit(e, index)}
      />

      <TkMessageDialog
        open={open}
        onOky={() => handleOk(modalText)}
        onCancel={() => setOpen(false)}
        title={`確認（${modalText}）`}
        contextText={`${modalText}を行いますが、問題ないでしょうか。`}
        cancelText="いいえ"
        okText="はい"
      />
    </Box>
  );
};

export default SCRW140003;
